<template>
  <div class="home-section-title" :class="{ 'locale-zh-CN': isZhLocale }">
    <h2 class="home-section-title__cn">{{ title }}</h2>
    <div v-if="subtitle" class="home-section-title__en-row">
      <span class="home-section-title__en">{{ subtitle }}</span>
      <img
        class="home-section-title__deco"
        :src="decoIcon"
        alt=""
        @error="onImgError"
      />
    </div>
  </div>
</template>

<script>
import { getCurrentLocale } from '@/utils/i18nText'
import { getSafeImage, handleImgError } from '@/utils/imageFallback'
import { localeImg } from '@/utils/localeAsset'

export default {
  name: 'HomeSectionTitle',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    },
    /** 英文右侧装饰图，默认 home_new 矩形 44 */
    decoSrc: {
      type: [String, Object],
      default: null
    }
  },
  computed: {
    isZhLocale() {
      return getCurrentLocale() === 'zh-CN'
    },
    decoIcon() {
      if (this.decoSrc) return getSafeImage(this.decoSrc)
      return localeImg('home_new/aliases/section-title-deco.png')
    }
  },
  methods: {
    onImgError(e) {
      handleImgError(e)
    }
  }
}
</script>

<style lang="scss" scoped>
.home-section-title {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  background: transparent;
}

.home-section-title__cn {
  margin: 0;
  padding: 0;
  font-size: 20px;
  font-weight: 700;
  color: #2a2418;
  letter-spacing: 1px;
  line-height: 1.2;
}

.home-section-title__en-row {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: transparent;
}

.home-section-title__en {
  font-size: 11px;
  color: #a0903c;
  letter-spacing: 1px;
  text-transform: uppercase;
  font-weight: 500;
  line-height: 1.2;
}

.home-section-title__deco {
  width: 18px;
  height: 15px;
  object-fit: contain;
  flex-shrink: 0;
  display: block;
}

.home-section-title.locale-zh-CN {
  gap: 4px;

  .home-section-title__cn {
    font-size: 26px;
  }

  .home-section-title__en {
    font-size: 14px;
  }

  .home-section-title__deco {
    width: 24px;
    height: 20px;
  }
}
</style>
